export default __webpack_public_path__ + "static/media/052.d6d7d76c.jpg";